'use client';

import { useLocalizedLinks } from '@/components/core/hooks';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const ConsentModal = () => {
  const pathname = usePathname();
  const links = useLocalizedLinks();
  useEffect(() => {
    if (links.privacyPolicy() === pathname || pathname.endsWith('/privacy-policy/')) {
      return;
    }
    // @ts-ignore
    import('@/components/third-party/inmobi');
  }, [pathname, links]);
  return null;
};

export default ConsentModal;
